export const ABHA_HEALTH_RECORD_FIELDS = {
  DIAGNOSTIC_REPORT_lAB: "Diagnostic Report Lab",
  MEDICATION_REQUEST: "Medication Request",
  OBSERVATION:"Observation",
  ENCOUNTER_CLASSIFICATION: "Encounter Classification",
  ENCOUNTER_TYPE: "Encounter Type",
  ENCOUNTER_SERVICE_TYPE: "Encounter Service Type",
  ENCOUNTER_PRIORITY: "Encounter Priority",
  ENCOUNTER_PERIOD_START: "Encounter Period start",
  ENCOUNTER_PERIOD_END: "Encounter Period end",
  ENCOUNTER_REASON: "Encounter Reason",
  ENCOUNTER_DIAGNOSIS_USE: "Encounter Diagnosis Use",
  DISPLAY_NAME: "displayName",
}
export const ABHA_HEALTH_RECORD_NAVS = {
  DIAGNOSTIC_REPORT: "DiagnosticReport",
  DISCHARGE_SUMMARY: "DischargeSummary",
  HEALTH_DOCUMENT_RECORD: "HealthDocumentRecord",
  OP_CONSULTATION: "OPConsultation",
  IMMUNIZATION_RECORD:"ImmunizationRecord",
  PRESCRIPTION: "Prescription",
  WELLNESS_RECORD: "WellnessRecord",
  INVOICE: "Invoice",
}
export const ABDM_PROFILES = [
  {title: "Diagnostic", icon: "diagnosticIcon", value: "DiagnosticReport"},
  {title: "Discharge Summary", icon: "dischargeIcon", value: "DischargeSummary"},
  {title: "OP Consultation", icon: "opconsultIcon", value: "OPConsultation"},
  {title: "Prescription", icon: "prescriptionIcon", value: "Prescription"},
  {title: "Wellness", icon: "wellnessIcon", value: "WellnessRecord"},
  {title: "Immunization", icon: "immunizationIcon", value: "ImmunizationRecord"},
  {title: "Invoice", icon: "invoiceIcon", value: "Invoice"},
  {title: "Health Document", icon: "documentRefIcon", value: "HealthDocumentRecord"},
]

export const ABHA_HEALTH_RECORD_VIEW_NAVS = {
  CONSENT_INIT_REQUEST: "Consent Init Request",
  CONSENT_STATUS: "Consent Status",
  VIEW_RECORDS: "View Records",
}

export const ABHA_HEALTH_RECORD_HI_TYPES = {
  DIAGNOSTIC_REPORT: "Diagnostic Report",
  DISCHARGE_SUMMARY: "Discharge Summary",
  HEALTH_DOCUMENT_RECORD: "Health Document Record",
  OP_CONSULTATION: "OP Consultation",
  PRESCRIPTION: "Prescription",
  WELLNESS_RECORD: "Wellness Record",
  IMMUNIZATION_RECORD: "Immunization Record",
  INVOICE: "Invoice",
};

export const RECORD_STATUS = [
  {label: "Preliminary", value: "preliminary"},
  {label: "Final", value: "final"},
  {label: "Amended", value: "amended"},
  {label: "Entered-in-error", value: "entered-in-error"},
]

export const FORM_OBSERVATION_FIELDS = {
  STATUS: "status",
  CODE: "observationCode",
  VALUE: "observationValue",
  UNITS: "observationUnits",
}

export const MEDICATION_REQUEST_STATUS = [
  { label: "Active", value: "active" },
  { label: "On Hold", value: "on-hold" },
  { label: "Cancelled", value: "cancelled" },
  { label: "Completed", value: "completed" },
  { label: "Entered in Error", value: "entered-in-error" },
  { label: "Stopped", value: "stopped" },
  { label: "Draft", value: "draft" },
  { label: "Unknown", value: "unknown" },
];

export const MEDICATION_REQUEST_INTENT = [
  { label: "Proposal", value: "proposal" },
  { label: "Plan", value: "plan" },
  { label: "Order", value: "order" },
  { label: "Original Order", value: "original-order" },
  { label: "Reflex Order", value: "reflex-order" },
  { label: "Filler Order", value: "filler-order" },
  { label: "Instance Order", value: "instance-order" },
  { label: "Option", value: "option" },
];

export const MEDICATION_ADDITIONAL_INSTRUCTION = [
  { label: "Half to one hour before food", value: "311501008" },
  { label: "With or after food", value: "311504000" },
  { label: "Times", value: "417929005" },
  { label: "Contains aspirin", value: "417980006" },
  { label: "Dissolve or mix with water before taking", value: "417995008" },
  { label: "Warning. Causes drowsiness which may continue the next day. If affected do not drive or operate machinery. Avoid alcoholic drink", value: "418071006" },
  { label: "Contains an aspirin-like medicine", value: "418194009" },
  { label: "Do not take anything containing aspirin while taking this medicine", value: "418281004" },
  { label: "Do not take more than . . . in 24 hours or . . . in any one week", value: "418443006" },
  { label: "Avoid exposure of skin to direct sunlight or sun lamps", value: "418521000" },
  { label: "Take at regular intervals. Complete the prescribed course unless otherwise directed", value: "418577003" },
  { label: "Do not take with any other paracetamol products", value: "418637003" },
  { label: "Warning. May cause drowsiness", value: "418639000" },
  { label: "Swallowed whole, not chewed", value: "418693002" },
  { label: "Warning. Follow the printed instructions you have been given with this medicine", value: "418849000" },
  { label: "Contains aspirin and paracetamol. Do not take with any other paracetamol products", value: "418850000" },
  { label: "Warning. May cause drowsiness. If affected do not drive or operate machinery. Avoid alcoholic drink", value: "418914006" },
  { label: "Warning. May cause drowsiness. If affected do not drive or operate machinery", value: "418954008" },
  { label: "Sucked or chewed", value: "418991002" },
  { label: "Allow to dissolve under the tongue. Do not transfer from this container. Keep tightly closed. Discard eight weeks after opening", value: "419111009" },
  { label: "Do not take milk, indigestion remedies, or medicines containing iron or zinc at the same time of day as this medicine", value: "419115000" },
  { label: "With plenty of water", value: "419303009" },
  { label: "Do not take more than 2 at any one time. Do not take more than 8 in 24 hours", value: "419437002" },
  { label: "Caution flammable: keep away from fire or flames", value: "419439004" },
  { label: "Do not stop taking this medicine except on your doctor's advice", value: "419444006" },
  { label: "Each", value: "419473009" },
  { label: "Dissolved under the tongue", value: "419529008" },
  { label: "Warning. Avoid alcoholic drink", value: "419822006" },
  { label: "This medicine may color the urine", value: "419974005" },
  { label: "Do not take more than . . . in 24 hours", value: "420003005" },
  { label: "Do not take indigestion remedies or medicines containing iron or zinc at the same time of day as this medicine", value: "420082003" },
  { label: "Do not take indigestion remedies at the same time of day as this medicine", value: "420110001" },
  { label: "To be spread thinly", value: "420162004" },
  { label: "Until gone", value: "420652005" },
  { label: "Then discontinue", value: "421484000" },
  { label: "Follow directions", value: "421769005" },
  { label: "Until finished", value: "421984009" },
  { label: "Then stop", value: "422327006" },
  { label: "Use with caution", value: "428579001" },
  { label: "Take on an empty stomach", value: "717154004" }
];


export const MANUFACTURER_FORM_FIELDS_NAMES = {
  NAME: 'manufacturerName',
  ADDRESS_TEXT:"addressText",
  EMAIL:"email",
  STATE: 'state',
  CITY: 'city',
  POSTALCODE: 'postalCode',
};

export const RECORD_TYPES = [
  {label: "Diagnostic Report Lab", value: "Diagnostic Report Lab"},
  // {label: "Diagnostic Report Imaging ", value: "Diagnostic Report Imaging "},
  // {label: "Document Reference", value: "Document Reference"},
]

export const DIAGNOSTIC_REPORT_lAB_STATUS = [
  {label: "Registered", value: "registered"},
  {label: "Partial", value: "partial"},
  {label: "Preliminary", value: "preliminary"},
  {label: "Final", value: "final"},
]

export const OBSERVATION_STATUS = [
  {label: "Registered", value: "registered"},
  {label: "Final", value: "final"},
  {label: "Preliminary", value: "preliminary"},
  {label: "Amended", value: "amended"},
]
export const ENCOUNTER_FIELDS = {
  DIAGNOSIS_USE: "diagnosisUse"
}
export const ENCOUNTER_STATUS = [
  { label: "Planned", value: "planned" },
  { label: "Arrived", value: "arrived" },
  { label: "Triaged", value: "triaged" },
  { label: "In Progress", value: "in-progress" },
  { label: "On Leave", value: "onleave" },
  { label: "Finished", value: "finished" },
  { label: "Cancelled", value: "cancelled" },
];

export const ENCOUNTER_CLASSIFICATION_OPTIONS = [
  { label: "Ambulatory", value: "AMB" },
  { label: "Emergency", value: "EMER" },
  { label: "Field", value: "FLD" },
  { label: "Home health", value: "HH" },
  { label: "Inpatient encounter", value: "IMP" },
  { label: "Inpatient acute", value: "ACUTE" },
  { label: "Inpatient non-acute", value: "NONAC" },
  { label: "Observation encounter", value: "OBSENC" },
  { label: "Pre-admission", value: "PRENC" },
  { label: "Short stay", value: "SS" },
  { label: "Virtual", value: "VR" }
];

export const DISCHARGE_SUMMARY_ALLERGY_INTOLERANCE = {
  CLINICAL_STATUS: "clinicalStatus",
  CODE: "allergyIntoleranceCode"
}

export const CLINICAL_STATUS_OPTIONS = [
  { "label": "Active", "value": "active" },
  { "label": "Inactive", "value": "inactive" },
  { "label": "Resolved", "value": "resolved" }
]

export const MEDICATION_ROUTE_OPTIONS = [
  { label: "Topical route", value: "Topical route" },
  { label: "Otic route", value: "Otic route" },
  { label: "Intra-articular route", value: "Intra-articular route" },
  { label: "Per vagina", value: "Per vagina" },
  { label: "Oral route", value: "Oral route" },
  { label: "Subcutaneous route", value: "Subcutaneous route" },
  { label: "Per rectum", value: "Per rectum" },
  { label: "Intraluminal route", value: "Intraluminal route" },
  { label: "Sublingual route", value: "Sublingual route" },
  { label: "Intraperitoneal route", value: "Intraperitoneal route" },
  { label: "Transdermal route", value: "Transdermal route" },
  { label: "Nasal route", value: "Nasal route" },
  { label: "Intravenous route", value: "Intravenous route" },
  { label: "Buccal route", value: "Buccal route" },
  { label: "Ophthalmic route", value: "Ophthalmic route" },
  { label: "Intra-arterial route", value: "Intra-arterial route" },
  { label: "Intramedullary route", value: "Intramedullary route" },
  { label: "Intrauterine route", value: "Intrauterine route" },
  { label: "Intrathecal route", value: "Intrathecal route" },
  { label: "Intramuscular route", value: "Intramuscular route" },
  { label: "Urethral route", value: "Urethral route" },
  { label: "Gastrostomy route", value: "Gastrostomy route" },
  { label: "Jejunostomy route", value: "Jejunostomy route" },
  { label: "Nasogastric route", value: "Nasogastric route" },
  { label: "Dental use", value: "Dental use" },
  { label: "Endocervical use", value: "Endocervical use" },
  { label: "Endosinusial use", value: "Endosinusial use" },
  { label: "Endotracheopulmonary use", value: "Endotracheopulmonary use" },
  { label: "Extra-amniotic use", value: "Extra-amniotic use" },
  { label: "Gastroenteral use", value: "Gastroenteral use" },
  { label: "Gingival use", value: "Gingival use" },
  { label: "Intraamniotic use", value: "Intraamniotic use" },
  { label: "Intrabursal use", value: "Intrabursal use" },
  { label: "Intracardiac use", value: "Intracardiac use" },
  { label: "Intracavernous use", value: "Intracavernous use" },
  { label: "Intracervical route", value: "Intracervical route" },
  { label: "Intracoronary use", value: "Intracoronary use" },
  { label: "Intradermal use", value: "Intradermal use" },
  { label: "Intradiscal use", value: "Intradiscal use" },
  { label: "Intralesional use", value: "Intralesional use" },
  { label: "Intralymphatic use", value: "Intralymphatic use" },
  { label: "Intraocular use", value: "Intraocular use" },
  { label: "Intrapleural use", value: "Intrapleural use" },
  { label: "Intrasternal use", value: "Intrasternal use" },
  { label: "Intravesical use", value: "Intravesical use" },
  { label: "Ocular route", value: "Ocular route" },
  { label: "Oromucosal use", value: "Oromucosal use" },
  { label: "Periarticular use", value: "Periarticular use" },
  { label: "Perineural use", value: "Perineural use" },
  { label: "Subconjunctival use", value: "Subconjunctival use" },
  { label: "Intratracheal route", value: "Intratracheal route" },
  { label: "Intrabiliary route", value: "Intrabiliary route" },
  { label: "Epidural route", value: "Epidural route" },
  { label: "Suborbital route", value: "Suborbital route" },
  { label: "Caudal route", value: "Caudal route" },
  { label: "Intraosseous route", value: "Intraosseous route" },
  { label: "Intrathoracic route", value: "Intrathoracic route" },
  { label: "Enteral route", value: "Enteral route" },
  { label: "Intraductal route", value: "Intraductal route" },
  { label: "Intratympanic route", value: "Intratympanic route" },
  { label: "Intravenous central route", value: "Intravenous central route" },
  { label: "Intramyometrial route", value: "Intramyometrial route" },
  { label: "Gastro-intestinal stoma route", value: "Gastro-intestinal stoma route" },
  { label: "Colostomy route", value: "Colostomy route" },
  { label: "Periurethral route", value: "Periurethral route" },
  { label: "Intracoronal route", value: "Intracoronal route" },
  { label: "Retrobulbar route", value: "Retrobulbar route" },
  { label: "Intracartilaginous route", value: "Intracartilaginous route" },
  { label: "Intravitreal route", value: "Intravitreal route" },
  { label: "Intraspinal route", value: "Intraspinal route" },
  { label: "Orogastric route", value: "Orogastric route" },
  { label: "Transurethral route", value: "Transurethral route" },
  { label: "Intratendinous route", value: "Intratendinous route" },
  { label: "Intracorneal route", value: "Intracorneal route" },
  { label: "Oropharyngeal route", value: "Oropharyngeal route" },
  { label: "Peribulbar route", value: "Peribulbar route" },
  { label: "Nasojejunal route", value: "Nasojejunal route" },
  { label: "Fistula route", value: "Fistula route" },
  { label: "Surgical drain route", value: "Surgical drain route" },
  { label: "Intracameral route", value: "Intracameral route" },
  { label: "Paracervical route", value: "Paracervical route" },
  { label: "Intrasynovial route", value: "Intrasynovial route" },
  { label: "Intraduodenal route", value: "Intraduodenal route" },
  { label: "Intracisternal route", value: "Intracisternal route" },
  { label: "Intratesticular route", value: "Intratesticular route" },
  { label: "Intracranial route", value: "Intracranial route" },
  { label: "Tumour cavity route", value: "Tumour cavity route" },
  { label: "Paravertebral route", value: "Paravertebral route" },
  { label: "Intrasinal route", value: "Intrasinal route" },
  { label: "Transcervical route", value: "Transcervical route" },
  { label: "Subtendinous route", value: "Subtendinous route" },
  { label: "Intraabdominal route", value: "Intraabdominal route" },
  { label: "Subgingival route", value: "Subgingival route" },
  { label: "Intraovarian route", value: "Intraovarian route" },
  { label: "Ureteral route", value: "Ureteral route" },
  { label: "Peritendinous route", value: "Peritendinous route" },
  { label: "Intrabronchial route", value: "Intrabronchial route" },
  { label: "Intraprostatic route", value: "Intraprostatic route" },
  { label: "Submucosal route", value: "Submucosal route" },
  { label: "Surgical cavity route", value: "Surgical cavity route" },
  { label: "Ileostomy route", value: "Ileostomy route" },
  { label: "Intravenous peripheral route", value: "Intravenous peripheral route" },
  { label: "Periosteal route", value: "Periosteal route" },
  { label: "Esophagostomy route", value: "Esophagostomy route" },
  { label: "Urostomy route", value: "Urostomy route" },
  { label: "Laryngeal route", value: "Laryngeal route" },
  { label: "Intrapulmonary route", value: "Intrapulmonary route" },
  { label: "Mucous fistula route", value: "Mucous fistula route" },
  { label: "Nasoduodenal route", value: "Nasoduodenal route" },
  { label: "Body cavity route", value: "Body cavity route" },
  { label: "Intraventricular route - cardiac", value: "Intraventricular route - cardiac" },
  { label: "Intracerebroventricular route", value: "Intracerebroventricular route" },
  { label: "Percutaneous route", value: "Percutaneous route" },
  { label: "Interstitial route", value: "Interstitial route" },
  { label: "Intraesophageal route", value: "Intraesophageal route" },
  { label: "Intragingival route", value: "Intragingival route" },
  { label: "Intravascular route", value: "Intravascular route" },
  { label: "Intradural route", value: "Intradural route" },
  { label: "Intrameningeal route", value: "Intrameningeal route" },
  { label: "Intragastric route", value: "Intragastric route" },
  { label: "Intrapericardial route", value: "Intrapericardial route" },
  { label: "Intralingual route", value: "Intralingual route" },
  { label: "Intrahepatic route", value: "Intrahepatic route" },
  { label: "Conjunctival route", value: "Conjunctival route" },
  { label: "Intraepicardial route", value: "Intraepicardial route" },
  { label: "Transendocardial route", value: "Transendocardial route" },
  { label: "Transplacental route", value: "Transplacental route" },
  { label: "Intracerebral route", value: "Intracerebral route" },
  { label: "Intraileal route", value: "Intraileal route" },
  { label: "Periodontal route", value: "Periodontal route" },
  { label: "Peridural route", value: "Peridural route" },
  { label: "Lower respiratory tract route", value: "Lower respiratory tract route" },
  { label: "Intramammary route", value: "Intramammary route" },
  { label: "Intratumor route", value: "Intratumor route" },
  { label: "Transtympanic route", value: "Transtympanic route" },
  { label: "Transtracheal route", value: "Transtracheal route" },
  { label: "Respiratory tract route", value: "Respiratory tract route" },
  { label: "Digestive tract route", value: "Digestive tract route" },
  { label: "Intraepidermal route", value: "Intraepidermal route" },
  { label: "Intrajejunal route", value: "Intrajejunal route" },
  { label: "Intracolonic route", value: "Intracolonic route" },
  { label: "Cutaneous route", value: "Cutaneous route" },
  { label: "Arteriovenous fistula route", value: "Arteriovenous fistula route" },
  { label: "Intraneural route", value: "Intraneural route" },
  { label: "Intramural route", value: "Intramural route" },
  { label: "Extracorporeal route", value: "Extracorporeal route" },
  { label: "Infiltration route", value: "Infiltration route" },
  { label: "Epilesional route", value: "Epilesional route" },
  { label: "Extracorporeal hemodialysis route", value: "Extracorporeal hemodialysis route" },
  { label: "Intradialytic route", value: "Intradialytic route" },
  { label: "Suprachoroidal route", value: "Suprachoroidal route" },
  { label: "Intracorporus cavernosum route", value: "Intracorporus cavernosum route" },
  { label: "Sublesional route", value: "Sublesional route" },
  { label: "Intraglandular route", value: "Intraglandular route" },
  { label: "Intracholangiopancreatic route", value: "Intracholangiopancreatic route" },
  { label: "Intraportal route", value: "Intraportal route" },
  { label: "Peritumoral route", value: "Peritumoral route" },
  { label: "Posterior juxtascleral route", value: "Posterior juxtascleral route" },
  { label: "Subretinal route", value: "Subretinal route" },
  { label: "Sublabial use", value: "Sublabial use" }
]

export const DOSAGE_INSTRUCTION_OPTIONS = [
  { label: "Morning", value: "Morning" },
  { label: "Afternoon", value: "Afternoon" },
  { label: "Evening", value: "Evening" }
]

export const FAMILY_MEMBER_HISTORY_STATUS = [
  {label: "Partial", value: "partial"},
  {label: "Completed", value: "completed"},
  {label: "Entered-in-error ", value: "entered-in-error "},
  {label: "Health-unknown", value: "health-unknown"},
]
export const PROCEDURE_STATUS = [
  { label: "Preparation", value: "preparation" },
  { label: "In Progress", value: "in-progress" },
  { label: "Not Done", value: "not-done" },
  { label: "On Hold", value: "on-hold" },
  { label: "Stopped", value: "stopped" },
  { label: "Completed", value: "completed" },
  { label: "Entered in Error", value: "entered-in-error" },
  { label: "Unknown", value: "unknown" },
];

export const CARE_PLAN_STATUS = [
  { label: "Draft", value: "draft" },
  { label: "Active", value: "active" },
  { label: "On Hold", value: "on-hold" },
  { label: "Revoked", value: "revoked" },
  { label: "Completed", value: "completed" },
  { label: "Entered in Error", value: "entered-in-error" },
  { label: "Unknown", value: "unknown" }
]

export const CARE_PLAN_INTENT = [
  { label: "Proposal", value: "proposal" },
  { label: "Plan", value: "plan" },
  { label: "Order", value: "order" },
  { label: "Option", value: "option" }
]

export const GOAL_STATUS_OPTIONS = [
  { label: "Proposed", value: "proposed" },
  { label: "Planned", value: "planned" },
  { label: "Accepted", value: "accepted" },
  { label: "Active", value: "active" },
  { label: "On Hold", value: "on-hold" },
  { label: "Completed", value: "completed" },
  { label: "Cancelled", value: "cancelled" },
  { label: "Entered in Error", value: "entered-in-error" },
  { label: "Unknown", value: "unknown" }
];

export const DOCUMENT_STATUS_OPTIONS = [
  { label: "Current", value: "current" },
  { label: "Superseded", value: "superseded" },
  { label: "Entered in Error", value: "entered-in-error" },
];

export const FORM_FIELDS_FOR_HEALTH_DOC = {
  STATUS:"healthDocStatus",
  DATE:"healthDocdate",
  TITLE:"healthDocTitle",
  DOC_REF:"healthDocRef"
}

export const FORM_FIELDS_FOR_CONSENT_INIT = {
  FROM: "dateFrom",
  TO: "dateTo",
  EXPIRY_DATE: "expiryDate",
  PURPOSE:"purpose"
}

export const PURPOSE_OF_REQUEST_OPTIONS = [
  { label: "Care Management", value: "Care Management" },
  { label: "Break the Glass", value: "Break the Glass" },
  { label: "Public Health", value: "Public Health" },
  { label: "Healthcare Payment", value: "Healthcare Payment" },
  { label: "Disease Specific Healthcare Research", value: "Disease Specific Healthcare Research" },
  { label: "Self Requested", value: "Self Requested" }
]  

export const FORM_FIELDS_FOR_OP_CONSULTATION = {
  STATUS:"opConsultationStatus",
  ENCOUNTER:"encounter",
  DATE:"dateTime",
  TITLE:"opConsultationTitle",
  CHIEF_COMPLAINTS:"opConsultationChiefComplaints",
  PHYSICAL_EXAMINATION:"physicalExamination",
  ALLERGIES:"allergies",
  MEDICAL_HISTORY:"medicalHistory",
  FAMILY_HISTORY:"familyHistory",
  INVESTIGATION_ADVICE:"investigationAdvice",
  MEDICATIONS:"Medications",
  FOLLOW_UP:"followUp",
  PROCEDURE:"procedure",
  REFERRAL:"referral",
  OTHER_OBSERVATIONS:"otherObservation",
  DOCUMENT_REFERENCE:"documentReference"
}

export const FORM_FIELDS_FOR_SERVICE_REQUEST = {
  TEXT: "textSummary",
  STATUS:"serviceRequestStatus",
  INTENT:"serviceRequestIntent",
  CODE:"serviceRequestcode"
}
export const SERVICE_REQUEST_STATUS_OPTIONS = [
  { label: "Draft", value: "draft" },
  { label: "Active", value: "active" },
  { label: "On Hold", value: "on-hold" },
  { label: "Revoked", value: "revoked" },
  { label: "Completed", value: "completed" },
  { label: "Entered in Error", value: "entered-in-error" },
  { label: "Unknown", value: "unknown" }
]

export const SERVICE_REQUEST_INTENT_OPTIONS = [
  { label: "Proposal", value: "proposal" },
  { label: "Plan", value: "plan" },
  { label: "Directive", value: "directive" },
  { label: "Order", value: "order" },
  { label: "Original Order", value: "original-order" },
  { label: "Reflex Order", value: "reflex-order" },
  { label: "Filler Order", value: "filler-order" },
  { label: "Instance Order", value: "instance-order" },
  { label: "Option", value: "option" }
]

export const PARTICIPANT_TYPE_OPTIONS = [
  { label: "Admitter", value: "ADM" },
  { label: "Attender", value: "ATND" },
  { label: "Callback contact", value: "CALLBCK" },
  { label: "Consultant", value: "CON" },
  { label: "Discharger", value: "DIS" },
  { label: "Escort", value: "ESC" },
  { label: "Referrer", value: "REF" },
  { label: "Secondary performer", value: "SPRF" },
  { label: "Primary performer", value: "PPRF" },
  { label: "Participation", value: "PART" },
  { label: "Translator", value: "translator" },
  { label: "Emergency", value: "emergency" }
];


export const FORM_FIELDS_FOR_APPOINTMENT = {
  STATUS: "appointmentStatus",
  SERVICE_CATEGORY: "serviceCategory",
  SERVICE_TYPE: "seriveType",
  SPECIALITY: "speciality",
  APPOINTMENT_TYPE: "appointmentType",
  REASON_CODE: "reasonCode",
  START: "appointmentStart",
  END: "appointmentEnd",
  PARTICIPANT_STATUS: "participantStatus",
  PARTICIPANT_TYPE: "participantType",
  DESCRIPTION: "Description"
}

export const APPOINTMENT_REASON_OPTIONS = [
  {
    label: "Routine appointment - default if not valued",
    value: "ROUTINE"
  },
  {
    label: "A previously unscheduled walk-in visit",
    value: "WALKIN"
  },
  {
    label: "A routine check-up, such as an annual physical",
    value: "CHECKUP"
  },
  {
    label: "A follow up visit from a previous appointment",
    value: "FOLLOWUP"
  },
  {
    label: "Emergency appointment",
    value: "EMERGENCY"
  }
];

export const SERVICE_CATEGORY_OPTIONS = [
  { label: "Adoption", value: "1" },
  { label: "Aged Care", value: "2" },
  { label: "Allied Health", value: "34" },
  { label: "Alternative & Complementary Therapies", value: "3" },
  { label: "Child Care and/or Kindergarten", value: "4" },
  { label: "Child Development", value: "5" },
  { label: "Child Protection & Family Services", value: "6" },
  { label: "Community Health Care", value: "7" },
  { label: "Counselling", value: "8" },
  { label: "Crisis Line (GPAH use only)", value: "36" },
  { label: "Death Services", value: "9" },
  { label: "Dental", value: "10" },
  { label: "Disability Support", value: "11" },
  { label: "Drug/Alcohol", value: "12" },
  { label: "Education & Learning", value: "13" },
  { label: "Emergency Department", value: "14" },
  { label: "Employment", value: "15" },
  { label: "Financial & Material aid", value: "16" },
  { label: "General Practice/GP (doctor)", value: "17" },
  { label: "Hospital", value: "35" },
  { label: "Housing/Homelessness", value: "18" },
  { label: "Interpreting", value: "19" },
  { label: "Justice", value: "20" },
  { label: "Legal", value: "21" },
  { label: "Mental Health", value: "22" },
  { label: "NDIA", value: "38" },
  { label: "Physical Activity & Recreation", value: "23" },
  { label: "Regulation", value: "24" },
  { label: "Respite/Carer Support", value: "25" },
  { label: "Specialist Clinical Pathology - requires referral", value: "26" },
  { label: "Specialist Medical - requires referral", value: "27" },
  { label: "Specialist Obstetrics & Gynecology - requires referral", value: "28" },
  { label: "Specialist Paediatric - requires referral", value: "29" },
  { label: "Specialist Radiology/Imaging - requires referral", value: "30" },
  { label: "Specialist Surgical - requires referral", value: "31" },
  { label: "Support group/s", value: "32" },
  { label: "Test Message (HSD admin use only)", value: "37" },
  { label: "Transport", value: "33" }
];


export const APPOINTMENT_STATUS_OPTIONS = [
  { label: "Proposed", value: "proposed" },
  { label: "Pending", value: "pending" },
  { label: "Booked", value: "booked" },
  { label: "Arrived", value: "arrived" },
  { label: "Fulfilled", value: "fulfilled" },
  { label: "Cancelled", value: "cancelled" },
  { label: "No Show", value: "noshow" },
  { label: "Entered in Error", value: "entered-in-error" },
  { label: "Checked In", value: "checked-in" },
  { label: "Waitlist", value: "waitlist" },
];

export const APPOINTMENT_PARTICIPANT_STATUS_OPTIONS = [
  { label: "Accepted", value: "accepted" },
  { label: "Declined", value: "declined" },
  { label: "Tentative", value: "tentative" },
  { label: "Needs Action", value: "needs-action" },
];


export const FORM_FIELDS_FOR_WELLNESS = {
  STATUS:"wellnessStatus",
  DATE:"dateTime",
  TITLE:"wellnessTitle",
}

export const FORM_FIELDS_FOR_OTHER_OBSERVATION = {
  STATUS: "observationStatus",
  CODE:"ObservationCode",
  VALUE_QUANTITY: "observationValueQunatity",
  VALUE_STRING: "",
  VALUE_CODEABLE:""
}

export const IMMUNIZATION_STATUS_OPTIONS = [
  { label: "Completed", value: "completed" },
  { label: "Entered in Error", value: "entered-in-error" },
  { label: "Not Done", value: "not-done" }
];

export const IMMUNIZATION_ROUTE_OPTIONS = [
  { label: "Injection, intradermal", value: "IDINJ" },
  { label: "Injection, intramuscular", value: "IM" },
  { label: "Inhalation, nasal, prongs", value: "NASINHLC" },
  { label: "Injection, intravenous", value: "IVINJ" },
  { label: "Swallow, oral", value: "PO" },
  { label: "Injection, subcutaneous", value: "SQ" },
  { label: "Transdermal", value: "TRNSDERM" }
];

export const IMMUNIZATION_SITE_OPTIONS = [
  { label: "Left arm", value: "LA" },
  { label: "Right arm", value: "RA" }
];

export const FORM_FIELDS_FOR_IMMUNIZATION = {
  STATUS:"immunizationStatus",
  VACCINE:"immunizationVaccine",
  OCCURRENCE:"immunizationOccurrence",
  LOT_NUMBER:"immunizationLotNumber",
  EXPIRATION_DATE:"immunizationExpirationDate",
  SITE:"immunizationSite",
  ROUTE:"immunizationRoute",
  REASON_CODE:"immunizationReason",
  DOSE_NUMBER:"immunizationDoseNumber"
}

export const FORM_FIELDS_FOR_ORGANIZATION = {
  NAME:"organizationName",
  TELECOM_SYSTEM:"telecomSystem",
  TELECOM_USE:"telecomUse",
  TELECOM_VALUE:"telecomValue",
  ADDRESS_TEXT:"addressText",
  ADDRESS_USE: "addressUse",
}

export const TELECOM_SYSTEM_OPTIONS = [
  { label: "Phone", value: "phone" },
  { label: "Fax", value: "fax" },
  { label: "Email", value: "email" },
  { label: "Pager", value: "pager" },
  { label: "URL", value: "url" },
  { label: "SMS", value: "sms" },
  { label: "Other", value: "other" }
];

export const TELECOM_USE_OPTIONS = [
  { label: "Home", value: "home" },
  { label: "Work", value: "work" },
  { label: "Temporary", value: "temp" },
  { label: "Old", value: "old" },
  { label: "Mobile", value: "mobile" }
];

export const LOCATION_STATUS_OPTIONS = [
  { label: "Active", value: "active" },
  { label: "Suspended", value: "suspended" },
  { label: "Inactive", value: "inactive" }
];


export const FORM_FIELDS_FOR_LOCATION = {
  STATUS: "locationStatus",
  NAME:"locationName",
  TELECOM_SYSTEM:"telecomSystem",
  TELECOM_USE:"telecomUse",
  TELECOM_VALUE:"telecomValue",
  ADDRESS_TEXT:"addressText"
}

export const ADDRESS_USE_OPTIONS = [
  { label: "Home", value: "home" },
  { label: "Work", value: "work" },
  { label: "Temporary", value: "temp" },
  { label: "Old", value: "old" },
  { label: "Billing", value: "billing" },
];


export const IMMUNIZATIO_RECORD = {
  STATUS: "immunizationCompositionStatus"
}

export const IMMUNIZATION_RECOMMENDATION_FIELDS = {
  DATE:"date",
  VACCINE_CODE: "vaccineCode",
  TARGET_DISEASE: "targetDisease",
  CONTRAINDICATED_VACCINE_CODE: "contraindicatedVaccineCode",
  FORCAST_STATUS: "forecastStatus",
  FORECAST_REASON:"forecastReason",
}

export const INVOICE_RECORD_FIELDS = {
  STATUS: "invoiceStatus",
  DATE: "invoiceDate",
  TITLE: "invoiceTitle",
  SUMMARY: "invoiceSummary"
}

export const FORM_FIELDS_FOR_INVOICE = {
  STATUS: "status",
  IDENTIFIER_TYPE: "invoiceIdentifierType",
  INVOICE_TYPE: "invoiceType",
  DATE: "date",
  CHARGE_CODE: "chargeCode",
  QUANTITY: "quantity",
  UNITS: "units",
  OCCURRENCE: "occurrence",
  PRICE_TEXT: "priceText",
  AMOUNT: "amount",
  CURRENCY: "currency",
  CHARGE_ITEM_STATUS: "status",
  CHARGE_ITEM_PRODUCT: "product",
  PRICE_COMPONENT_TYPE: "type",
  PRICE_COMPONENT_CODE: "priceComponentText",
  TOTAL_NET:"totalNet",
  TOTAL_GROSS: "totalGross",
}

export const INVOICE_STATUS = [
  { label: "Draft", value: "draft" },
  { label: "Issued", value: "issued" },
  { label: "Balanced", value: "balanced" },
  { label: "Cancelled", value: "cancelled" },
  { label: "Entered in Error", value: "entered-in-error" }
];

export const INVOIE_TYPE_OPTIONS = [
  { label: "Consultation", value: "00" },
  { label: "Pharmacy", value: "01" },
  { label: "IPD", value: "02" },
  { label: "OPD", value: "03" },
  { label: "Others", value: "99" }
];


export const CHARGE_ITEM_STATUS_OPTIONS = [
  { "label": "Planned", "value": "planned" },
  { "label": "Billable", "value": "billable" },
  { "label": "Not Billable", "value": "not-billable" },
  { "label": "Aborted", "value": "aborted" },
  { "label": "Billed", "value": "billed" },
  { "label": "Entered in Error", "value": "entered-in-error" },
  { "label": "Unknown", "value": "unknown" }
]

export const CHARGE_ITEM_CODE_OPTIONS = [
  { label: "Consultation", value: "00" },
  { label: "Pharmacy", value: "01" },
  { label: "IPD", value: "02" },
  { label: "OPD", value: "03" },
  { label: "Pathology", value: "04" },
  { label: "Medicines", value: "05" },
  { label: "Nursing Charges", value: "06" },
  { label: "Handling Charges", value: "07" },
  { label: "Delivery Charges", value: "08" },
  { label: "Others", value: "99" }
];


export const INVOICE_PRICE_COMPONENT_CODE_OPTIONS = [
  { "label": "MRP", "value": "00" },
  { "label": "Rate", "value": "01" },
  { "label": "Discount", "value": "02" },
  { "label": "CGST", "value": "03" },
  { "label": "SGST", "value": "04" }
];

export const INVOICE_PRICE_COMPONENT_TYPE_OPTIONS = [
  { "label": "Base Price", "value": "base" },
  { "label": "Surcharge", "value": "surcharge" },
  { "label": "Deduction", "value": "deduction" },
  { "label": "Discount", "value": "discount" },
  { "label": "Tax", "value": "tax" },
  { "label": "Informational", "value": "informational" }
];


export const AMOUNT_ISC_CODES = [
  { "label": "Indian rupee", "value": "INR" },
  { "label": "United Arab Emirates dirham", "value": "AED" },
  { "label": "Afghan afghani", "value": "AFN" },
  { "label": "Albanian lek", "value": "ALL" },
  { "label": "Armenian dram", "value": "AMD" },
  { "label": "Netherlands Antillean guilder", "value": "ANG" },
  { "label": "Angolan kwanza", "value": "AOA" },
  { "label": "Argentine peso", "value": "ARS" },
  { "label": "Australian dollar", "value": "AUD" },
  { "label": "Aruban florin", "value": "AWG" },
  { "label": "Azerbaijani manat", "value": "AZN" },
  { "label": "Bosnia and Herzegovina convertible mark", "value": "BAM" },
  { "label": "Barbados dollar", "value": "BBD" },
  { "label": "Bangladeshi taka", "value": "BDT" },
  { "label": "Bulgarian lev", "value": "BGN" },
  { "label": "Bahraini dinar", "value": "BHD" },
  { "label": "Burundian franc", "value": "BIF" },
  { "label": "Bermudian dollar", "value": "BMD" },
  { "label": "Brunei dollar", "value": "BND" },
  { "label": "Boliviano", "value": "BOB" },
  { "label": "Bolivian Mvdol (funds code)", "value": "BOV" },
  { "label": "Brazilian real", "value": "BRL" },
  { "label": "Bahamian dollar", "value": "BSD" },
  { "label": "Bhutanese ngultrum", "value": "BTN" },
  { "label": "Botswana pula", "value": "BWP" },
  { "label": "Belarusian ruble", "value": "BYN" },
  { "label": "Belize dollar", "value": "BZD" },
  { "label": "Canadian dollar", "value": "CAD" },
  { "label": "Congolese franc", "value": "CDF" },
  { "label": "Swiss franc", "value": "CHF" },
  { "label": "Chilean peso", "value": "CLP" },
  { "label": "Chinese yuan (Renminbi)", "value": "CNY" },
  { "label": "Colombian peso", "value": "COP" },
  { "label": "Costa Rican colon", "value": "CRC" },
  { "label": "Cuban convertible peso", "value": "CUC" },
  { "label": "Cuban peso", "value": "CUP" },
  { "label": "Czech koruna", "value": "CZK" },
  { "label": "Danish krone", "value": "DKK" },
  { "label": "Dominican peso", "value": "DOP" },
  { "label": "Algerian dinar", "value": "DZD" },
  { "label": "Egyptian pound", "value": "EGP" },
  { "label": "Ethiopian birr", "value": "ETB" },
  { "label": "Euro", "value": "EUR" },
  { "label": "Fiji dollar", "value": "FJD" },
  { "label": "British pound sterling", "value": "GBP" },
  { "label": "Ghanaian cedi", "value": "GHS" },
  { "label": "Hong Kong dollar", "value": "HKD" },
  { "label": "Hungarian forint", "value": "HUF" },
  { "label": "Indonesian rupiah", "value": "IDR" },
  { "label": "Iranian rial", "value": "IRR" },
  { "label": "Iraqi dinar", "value": "IQD" },
  { "label": "Israeli new shekel", "value": "ILS" },
  { "label": "Japanese yen", "value": "JPY" },
  { "label": "Kenyan shilling", "value": "KES" },
  { "label": "Kuwaiti dinar", "value": "KWD" },
  { "label": "Lao kip", "value": "LAK" },
  { "label": "Lebanese pound", "value": "LBP" },
  { "label": "Sri Lankan rupee", "value": "LKR" },
  { "label": "Malaysian ringgit", "value": "MYR" },
  { "label": "Mexican peso", "value": "MXN" },
  { "label": "Nepalese rupee", "value": "NPR" },
  { "label": "New Zealand dollar", "value": "NZD" },
  { "label": "Omani rial", "value": "OMR" },
  { "label": "Pakistani rupee", "value": "PKR" },
  { "label": "Philippine peso", "value": "PHP" },
  { "label": "Polish złoty", "value": "PLN" },
  { "label": "Qatari riyal", "value": "QAR" },
  { "label": "Russian ruble", "value": "RUB" },
  { "label": "Saudi riyal", "value": "SAR" },
  { "label": "Singapore dollar", "value": "SGD" },
  { "label": "South African rand", "value": "ZAR" },
  { "label": "South Korean won", "value": "KRW" },
  { "label": "Swedish krona", "value": "SEK" },
  { "label": "Swiss franc", "value": "CHF" },
  { "label": "Thai baht", "value": "THB" },
  { "label": "Turkish lira", "value": "TRY" },
  { "label": "United States dollar", "value": "USD" },
  { "label": "Vietnamese đồng", "value": "VND" },
  { "label": "Zambian kwacha", "value": "ZMW" },
  { "label": "Zimbabwean dollar", "value": "ZWL" }
]
